(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6889"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6889"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("37DY9", function(module, exports) {

$parcel$export(module.exports, "setCurrentPage", function () { return $24610797eb8c29c4$export$5e52cab53995b7b9; });
/**
 *  Sets styles on the top navbar to indicate the current page.
 * @param linkID the ID of the link in the top navbar that goes to the current page.
 */ function $24610797eb8c29c4$export$5e52cab53995b7b9(linkID) {
    var link = document.getElementById(linkID);
    if (link) link.className = 'current';
    else setTimeout(function() {
        $24610797eb8c29c4$export$5e52cab53995b7b9(linkID);
    }, 10); // allow the page to finish loading
}

});


var $37DY9 = parcelRequire("37DY9");
$37DY9.setCurrentPage('sdcPageLink');

})();
//# sourceMappingURL=sdc.8600fd31.js.map
